"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = combineReducers;
var _immutable = require("immutable");
// When you have multiple reducers for a single slice of state this function allows you to
// reduce the same Actions in the different reducers.
function combineReducers(reducerGroups) {
  var actionKeys = reducerGroups.reduce(function (accumulator, reducersGroup) {
    return accumulator.concat(Object.keys(reducersGroup));
  }, []);
  var allActions = (0, _immutable.Set)(actionKeys).toArray();
  var combinedReducers = {};
  allActions.forEach(function (action) {
    combinedReducers[action] = function (state, payload) {
      var newState = state;
      reducerGroups.forEach(function (reducerGroup) {
        if (Object.prototype.hasOwnProperty.call(reducerGroup, action)) {
          newState = reducerGroup[action](newState, payload);
        }
      });
      return newState;
    };
  });
  return combinedReducers;
}